import * as ko from "knockout";
import { c_mk_to_product, part } from "entitiesE";
import labels from "app/labels";

export class warranty_mk extends c_mk_to_product {
  maintenance_part: KnockoutObservable<part>;
  item_list_description: KnockoutComputed<string>;
  saved: KnockoutObservable<boolean>;
  edited: KnockoutObservable<boolean>;

  constructor(item: any) {
    super(item);
    this.maintenance_part = <KnockoutObservable<part>>this.loadRelation(item, part, "c_part_alias");

    this.maintenance_part.subscribe((newval) => {
      const part_id = newval?.part_id;
      this.mk_part_id(part_id ? part_id() : null);
    });

    this.saved = ko.computed(() => {
      return this.request_unit_id() != null;
    });

    this.item_list_description = ko.pureComputed(() => {
      return (this.mk_serial_id() && this.mk_serial_id().toUpperCase()) || "New Item";
    });
    this.install_counter.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_VALUE_REQ"),
      },
      digit: { params: true, message: labels.descr("cc_P_ENTER_VALID_NUMBER") },
      min: {
        params: 1,
        message: labels.descrWithParams("cc_P_VALUE_MIN", [1]),
      },
      max: {
        params: 60000000,
        message: labels.descrWithParams("cc_P_VALUE_MAX", [60000000]),
      },
    });
    this.device_life_counter_after.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_VALUE_REQ"),
      },
      digit: { params: true, message: labels.descr("cc_P_ENTER_VALID_NUMBER") },
      min: {
        params: 1,
        message: labels.descrWithParams("cc_P_VALUE_MIN", [1]),
      },
      max: {
        params: 60000000,
        message: labels.descrWithParams("cc_P_VALUE_MAX", [60000000]),
      },
    });
    this.edited = ko.computed(() => {
      return this.created_dttm() != null;
    });
  }
  toJSON = () => {
    let jsO = ko.toJS(this);
    delete jsO.defective_part;
    delete jsO.repl_part;
    delete jsO.good_will_transaction_check;
    delete jsO.saved;
    delete jsO.phenomenon_code_description;
    return jsO;
  };
}
